type GuardsContext = {
  guards: Record<string, boolean | undefined>;
};

type GuardImplementation = <TContext extends GuardsContext>(args: {
  context: TContext;
}) => boolean;

export const guards: Record<string, GuardImplementation> = {
  allowJourneyMoveIn: ({ context }) => {
    return !!context.guards.allowJourneyMoveIn;
  },
  hasAnyUnsupportedMeter: ({ context }) => {
    return !!context.guards.hasAnyUnsupportedMeter;
  },
  hasAnyMeterValidationRequired: ({ context }) => {
    return !!context.guards.hasAnyMeterValidationRequired;
  },
  meterValidationRequired: ({ context }) => {
    return !!context.guards.meterValidationRequired;
  },
  isElectricity: ({ context }) => {
    return !!context.guards.isElectricity;
  },
  isGas: ({ context }) => {
    return !!context.guards.isGas;
  },
  isNewToBrand: ({ context }) => {
    return !!context.guards.isNewToBrand;
  },
  isBGCustomer: ({ context }) => {
    return !!context.guards.isBGCustomer;
  },
  isBGECustomer: ({ context }) => {
    return !!context.guards.isBGECustomer;
  },
  isRelatedElectricityMeter: ({ context }) => {
    return !!context.guards.isRelatedElectricityMeter;
  },
  isExistingCutomer: ({ context }) => {
    return !context.guards.isNewToBrand;
  },
  hasMixedMeters: ({ context }) => {
    return !!context.guards.hasMixedMeters;
  },
  isMonthlyDirectDebit: ({ context }) => {
    return !!context.guards.isMonthlyDirectDebit;
  },
  isMoveInEligible: ({ context }) => {
    return !!context.guards.isMoveInEligible;
  },
  isAnyDirectDebit: ({ context }) => {
    return !!context.guards.isAnyDirectDebit;
  },
  hasMultipleDirectDebitTypes: ({ context }) => {
    return !!context.guards.hasMultipleDirectDebitTypes;
  },
  hasPSR: ({ context }) => {
    return !!context.guards.hasPSR;
  },
  isNepSplitSupply: ({ context }) => {
    return !!context.guards.isNepSplitSupply;
  },
  isSapSplitSupply: ({ context }) => {
    return !!context.guards.isSapSplitSupply;
  },
  isMixedNepSap: ({ context }) => {
    return !!context.guards.isMixedNepSap;
  },
  isPrePayOnly: ({ context }) => {
    return !!context.guards.isPrePayOnly;
  },
  showEvTariffInformation: ({ context }) => {
    return !!context.guards.showEvTariffInformation;
  },
  hasMeterExceptions: ({ context }) => {
    return !!context.guards.hasMeterExceptions;
  },
  allowAbandonedCart: ({ context }) => {
    return !!context.guards.allowAbandonedCart;
  },
  hasElectricityTOUMeter: ({ context }) => {
    return !!context.guards.hasElectricityTOUMeter;
  },
  isUpsellEnabled: ({ context }) => {
    return !!context.guards.isUpsellEnabled;
  },
  isUpsellEnabledMeterValidationRequired: ({ context }) => {
    return !!context.guards.isUpsellEnabledMeterValidationRequired;
  }
};
